import type { IconNode } from '../types';

/**
 * @name cricket-ball
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSA4IDMuNiA2LjYiIC8+CiAgPHBhdGggZD0ibTggMTEgMSAxIiAvPgogIDxwYXRoIGQ9Im0xMiAxNSAxIDEiIC8+CiAgPHBhdGggZD0ibTE2IDE5IDEuNCAxLjQiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiIC8+CiAgPHBhdGggZD0iTTggNSA2LjYgMy42IiAvPgogIDxwYXRoIGQ9Im0xMSA4IDEgMSIgLz4KICA8cGF0aCBkPSJtMTUgMTIgMSAxIiAvPgogIDxwYXRoIGQ9Ik0yMC40IDE3LjQgMTkgMTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/cricket-ball
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cricketBall: IconNode = [
  ['path', { d: 'M5 8 3.6 6.6', key: '48g51b' }],
  ['path', { d: 'm8 11 1 1', key: 'efx2pb' }],
  ['path', { d: 'm12 15 1 1', key: 'v44d5c' }],
  ['path', { d: 'm16 19 1.4 1.4', key: 'bvebko' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M8 5 6.6 3.6', key: '1ys5dv' }],
  ['path', { d: 'm11 8 1 1', key: '3muhrj' }],
  ['path', { d: 'm15 12 1 1', key: '1dh9uu' }],
  ['path', { d: 'M20.4 17.4 19 16', key: 'f6mx4s' }],
];

export default cricketBall;
